// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"4e70d42f","201":"ee288add","355":"5c0eb271","394":"1f9e2a9d","863":"6f573b82","888":"089035c6","942":"9ab915ff"}[chunkId] + ".chunk.css";
};